import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { Contact } from "src/app/models/contacts";
import { ContactsService } from "src/app/services/contacts.service";

@Component({
    selector: 'mwp-member-resourcs-contacts',
    templateUrl: './contacts.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MemberDocumentContactsComponent implements OnInit {

    public contacts: Contact[];
    public apiUrl = ContentHeaderKey.DocumentsContacts;

    constructor(
        private contactsService: ContactsService
    ) {
    }

    ngOnInit(): void {
        this.contactsService.getContacts().subscribe((response) => {
            this.contacts = response;
        });
    }

    public openTab(url: string): void {
        window.open(url, "_blank");
    }
}